import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import {OAuthModule} from 'angular-oauth2-oidc';
import {SharedModule} from '../shared/shared.module';
import {OAuthComponent} from './oauth/oauth.component';
import {ActivateComponent} from './activate/activate.component';
import {ChangeAvatarComponent} from './change-avatar/change-avatar.component';
import {ChangePasswordComponent} from './change-password/change-password.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {LoginComponent} from './login/login.component';
import {RegisterEtaxComponent} from './register-etax/register-etax.component';
import {ResendVerifyEmailComponent} from './resend-verify-email/resend-verify-email.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {SignUpComponent} from './sign-up/sign-up.component';
import {WaitingPageComponent} from './thankyou/thankyou.component';
import {UpdateProfileComponent} from './update-profile/update-profile.component';
import {TwofactorComponent} from './twofactor/twofactor.component';
import {SocialLogin} from './social-login';
import { RegisterCompanyDialogComponent } from './register-company-dialog/register-company-dialog.component';
import { UploadCertificateComponent } from './upload-certificate/upload-certificate.component';
import { PersonalCertificateComponent } from './personal-certificate/personal-certificate.component';
import { ConfirmDeleteComponent } from './confirm-delete/confirm-delete.component';
import { EditSecurityComponent } from './profile/security/edit-security.component';
import { AccountRoutingModule } from './account-routing.module';
import { ProfileMenuComponent } from './profile/profile-menu/profile-menu.component';
import { GeneralComponent } from './profile/general/general.component';
import { EditNotificationComponent } from './profile/notification/edit-notification.component';
import { PlanComponent } from './profile/plan/plan.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        ReactiveFormsModule,
        AccountRoutingModule,
        OAuthModule.forRoot()
    ],
    declarations: [
        ActivateComponent,
        ChangeAvatarComponent,
        ChangePasswordComponent,
        ForgotPasswordComponent,
        LoginComponent,
        OAuthComponent,
        RegisterEtaxComponent,
        ResendVerifyEmailComponent,
        ResetPasswordComponent,
        SignUpComponent,
        WaitingPageComponent,
        UpdateProfileComponent,
        TwofactorComponent,
        RegisterCompanyDialogComponent,
        UploadCertificateComponent,
        PersonalCertificateComponent,
        ConfirmDeleteComponent,
        ProfileMenuComponent,
        GeneralComponent,
        EditSecurityComponent,
        EditNotificationComponent,
        PlanComponent
    ],
    exports: [
        LoginComponent,
        ProfileMenuComponent,
    ],
    providers: [
        SocialLogin
    ]
})
export class AccountModule {
}
